export const PAYMENT_URL =
  'https://rrc-ural.ru/konkursy/item/2174-vi-vserossijskaya-olimpiada-po-muzykalno-teoreticheskim-predmetam-im-z-a-vizelya';

export const PARTICIPATION_URL =
  'https://forms.yandex.ru/cloud/6a4b592a95add5c193414f1c';

export const OLYMPIC_RULES_URL =
  'https://www.dropbox.com/scl/fi/zh959sn9v05ogrdm316bp/VI.pdf?rlkey=0y0b2pvxugtqb22lntekbnrxn&st=lf0nkgeb&dl=1';

export const localApi = 'http://localhost:3001';

export const mainApi = 'https://xn--80aagghlcaexjdxr3w.xn--p1ai/api';
